import 'react-app-polyfill/stable';
import 'intl';
import 'intl/locale-data/jsonp/en.js';
import 'intl/locale-data/jsonp/zh.js';
import intl from 'react-intl-universal';
import '@formatjs/intl-locale/polyfill';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from '@/App';
import 'react-photo-view/dist/react-photo-view.css';
import '@/assets/scss/common/base.scss';
import * as serviceWorker from '@/serviceWorker';
import store from '@/store/index';
import common from '@/utils/common';
import { setHtmlFontSize } from '@/utils/utils';
import ErrorBoundary from '@/components/ErrorBundary';
import './index.scss';

// app locale data
const locales = {
  "en-US": require('./locales/en-US.json'),
  "zh-CN": require('./locales/zh-CN.json'),
};

const themeMap = [
  { key: "blingabc", value: "bli" },
  { key: "meike", value: "mke" },
  { key: "roombox", value: "gen" },
];
const setTheme = (theme = "", mode = "dark") => {
  let target = themeMap.find(_theme => theme.toLowerCase().includes(_theme.key));
  let themeName = target ? target.value : theme;
  const root = document.getElementsByTagName("HTML")[0];
  root.classList.add(`theme-${themeName}`, `mode-${mode}`);
  store.dispatch({ type: 'SET_THEME', payload: { theme: themeName } });
};

const searchParams = common.getSearchParam();
// cid mainId uid role nickName token url language
console.log('href: ', window.location.href);
const language = common.getLanguage();
let { theme, mode, token: urlToken } = searchParams;
setTheme(theme || 'roombox', mode || 'dark');
// 设置token处都需要加一层本地缓存逻辑
const cacheToken = localStorage.getItem('vod_token');
const token = urlToken || cacheToken || '';
if (token) {
  store.dispatch({
    type: 'SET_TOKEN',
    payload: {
      token,
    },
  });
  localStorage.setItem('vod_token', token); // 可能为url上取的，需要更新
  // 删除url token参数
  const url = new URL(window.location.href);
  url.searchParams.delete('token');
  window.history.replaceState({}, document.title, url.toString());
}
store.dispatch({
  type: 'SET_SEARCH_PARAMS',
  payload: {
    searchParams,
  },
});

setHtmlFontSize();
window.onresize = () => { setHtmlFontSize() };

console.log(`%c[NEW]`, 'color:blue;font-size: 14px;font-weight: bolder;');

intl.init({
  currentLocale: language.includes('en') ? 'en-US' : 'zh-CN',
  locales,
})
  .then(() => {
    // After loading CLDR locale data, start to render
    ReactDOM.render(
      <Provider store={store} >
        <ErrorBoundary errorType="top" children={<App />} />
      </Provider>
      , document.getElementById('root')
    );
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
